export default {
  bookingStatus: {
    Booked: 0,
    Allocated: 1,
    Accepted: 2,
    Cleared: 3
  },
  bookingDispatchStatus: {
    Unsent: 0,
    Sent: 1,
    Delivered: 2,
    Accepted: 3,
  },
  viewSelection:{
    All:0,
    Cars:1,
    Bookings:2,
    TwoRowsOfCars:3
  }
}